import React, { useState, useRef, useEffect } from "react";
import LoginDropdown from "./LoginDropdown";
import "../App.css"
const Header = () => {
  
  const texts = [
    "🚀 Welcome to BSK Boutique",
    "🔥 Free Shipping on all orders!",
    "💻 Thanks for shopping with us!",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [texts.length]);

  // 🔹 Toggle Login Dropdown
  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  // 🔹 Hide dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div>
      {/* 🔹 Top scrolling text bar */}
      <div className="scroll-header bg-light py-1">
        <marquee behavior="scroll" direction="left" scrollamount="8">
          {texts[currentIndex]}
        </marquee>
      </div>

      {/* 🔹 Main Header */}
      <div className="jumbo-header fixed-top bg-white shadow-sm">
        <div className="container">
          <div className="row align-items-center py-2">
            
            {/* LEFT SIDE - Brand & Links */}
            <div className="col-lg-7 d-lg-flex d-none align-items-center">
              <div className="col-4 logo-ht d-flex padding-center">
                <a className="navbar-brand fw-bold fs-4 text-dark" href="#">
                  BSK Boutique
                </a>
              </div>

              <div className="col-2">
                <a href="bsk-home " className="text-link header-text text-dark">
                  Home
                </a>
              </div>

              <div className="col-2">
                <a href="#" className="text-link header-text text-dark">
                  About
                </a>
              </div>

              <div className="col-2">
                <a href="#" className="text-link header-text text-dark">
                  BSK-World
                </a>
              </div>

              <div className="col-3 px-1">
                <a href="#" className="text-link header-text text-dark">
                  Size Chart
                </a>
              </div>
            </div>

            {/* RIGHT SIDE - Search & Icons */}
            <div className="col-lg-5 col-12 d-flex align-items-center justify-content-end">
              {/* Search Bar */}
              <div className="col-7 px-3">
                <form role="search">
                  <input
                    className="form-control form-control-sm"
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                  />
                </form>
              </div>

              {/* Icons Section */}
              <div className="col-4 d-flex justify-content-around align-items-center">
                {/* User Dropdown */}
                <div className="position-relative" ref={dropdownRef}>
                  <i
                    className="fa-regular fa-user cursor-pointer fs-5"
                    onClick={toggleDropdown}
                    style={{ cursor: "pointer" }}
                  ></i>
                  {showDropdown && <LoginDropdown />}
                </div>

               
                <i
                  className="fa-solid fa-cart-shopping fs-5"
                  style={{ cursor: "pointer" }}
                ></i>

                
                <i
                  className="fa-solid fa-heart fs-5"
                  style={{ cursor: "pointer" }}
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
